export default [
  { code: 'US', name: 'United States', prefix: '+1' },
  { code: 'CA', name: 'Canada', prefix: '+1' },
  { code: 'GB', name: 'United Kingdom', prefix: '+44' },
  { code: 'BS', name: 'Bahamas', prefix: '+1242' },
  { code: 'HR', name: 'Croatia', prefix: '+385' },
  { code: 'DE', name: 'Germany', prefix: '+49' },
  { code: 'FR', name: 'France', prefix: '+33' },
  { code: 'GR', name: 'Greece', prefix: '+30' },
  { code: 'IT', name: 'Italy', prefix: '+39' },
  { code: 'PE', name: 'Peru', prefix: '+51' },
  { code: 'PR', name: 'Puerto Rico', prefix: '+1787' },
  { code: 'SA', name: 'Saudi Arabia', prefix: '+966' },
  { code: 'ES', name: 'Spain', prefix: '+34' },
  { code: 'TC', name: 'Turks and Caicos Islands', prefix: '+1649' },
  { code: 'AE', name: 'United Arab Emirates', prefix: '+971' },
  { code: 'VI', name: 'US Virgin Islands', prefix: '+1340' },
  { code: 'PH', name: 'Philippines', prefix: '+63' },
];
